import Link from "next/link";
import { usePath } from "../contexts/PathContext";
function SwitchpageButton() {
  const { isMerchantPage } = usePath();
  const classNameValue = isMerchantPage ? "merchant" : "employee";
  return (
    <li className={`switch-page-btn ${classNameValue}`}>
      <Link
        href={isMerchantPage ? "/" : "/merchant"}
        className="relative block text-white px-4 py-2"
        onClick={() => window.scrollTo(0, 0)}
      >
        {isMerchantPage ? "我是工作者" : "我是商家"}
      </Link>
    </li>
  );
}

export default SwitchpageButton;
